// Event names are centralized so funnels stay stable even if call sites move.
// Server-side event names live in posthogServer.ts; keep the two lists
// disjoint so client and server captures never double-count one funnel step.
export const analyticsEvents = {
  SIGNUP_COMPLETED: 'signup_completed',
  SIGNUP_EMAIL_VERIFIED: 'signup_email_verified',
  SIGNUP_STARTED: 'signup_started',
  INTENT_PROMPT_SHOWN: 'intent_prompt_shown',
  INTENT_PROMPT_ANSWERED: 'intent_prompt_answered',
  INTENT_PROMPT_SKIPPED: 'intent_prompt_skipped',
  SIGNED_IN: 'signed_in',
  AUTH_CALLBACK_FAILED: 'auth_callback_failed',
  PASSWORD_RESET_REQUESTED: 'password_reset_requested',
  ONBOARDING_STEP_COMPLETED: 'onboarding_step_completed',
  ONBOARDING_COMPLETED: 'onboarding_completed',
  DISPLAY_VIEWED: 'display_viewed',
  HOME_QUICK_FILTER_CLICKED: 'home_quick_filter_clicked',
  HOME_DISPLAY_SEARCH_SUBMITTED: 'home_display_search_submitted',
  DISCOVERY_VIEWED: 'discovery_viewed',
  DISCOVERY_FILTER_CHANGED: 'discovery_filter_changed',
  DISCOVERY_SEARCHED: 'discovery_searched',
  DISCOVERY_OTHER_SEASON_OFFERED: 'discovery_other_season_offered',
  DISCOVERY_OTHER_SEASON_CLICKED: 'discovery_other_season_clicked',
  DISCOVERY_CARD_OPENED: 'discovery_card_opened',
  DISCOVERY_MAP_OPENED: 'discovery_map_opened',
  DISCOVERY_ON_NOW_TOGGLED: 'discovery_on_now_toggled',
  SEQUENCE_VIEWED: 'sequence_viewed',
  GHOST_RUN_PLAYED: 'ghost_run_played',
  HEARTBEAT_SCRUBBED: 'heartbeat_scrubbed',
  HOUSE_LAYOUT_DROPPED: 'house_layout_dropped',
  FIT_LIST_VIEWED: 'fit_list_viewed',
  FIT_PREVIEW_PLAYED: 'fit_preview_played',
  FIT_MAPPING_REQUESTED: 'fit_mapping_requested',
  HOUSE_SAVED: 'house_saved',
  HOUSE_DRAWN: 'house_drawn',
  FIT_DEMO_STARTED: 'fit_demo_started',
  FIT_TOUR_CLOSED: 'fit_tour_closed',
  SIGN_IN_WALL_SHOWN: 'sign_in_wall_shown',
  SEQUENCE_DOWNLOAD_STARTED: 'sequence_download_started',
  SEQUENCE_DOWNLOAD_FAILED: 'sequence_download_failed',
  DOWNLOADS_DOWNLOAD_CLICKED: 'downloads_download_clicked',
  MY_DOWNLOADS_VIEWED: 'my_downloads_viewed',
  CHECKOUT_STARTED: 'checkout_started',
  CHECKOUT_FAILED: 'checkout_failed',
  CHECKOUT_COMPLETED: 'checkout_completed',
  CHECKOUT_CONFIRMATION_FAILED: 'checkout_confirmation_failed',
  CONNECT_ONBOARDING: 'connect_onboarding_step',
  UPLOAD_WIZARD_STEP: 'upload_wizard_step',
  UPLOAD_DRAFT_SAVED: 'upload_draft_saved',
  UPLOAD_DRAFT_RESUMED: 'upload_draft_resumed',
  UPLOAD_FILE_METADATA_PREFILLED: 'upload_file_metadata_prefilled',
  PORCH_LIGHT_RENDERED: 'porch_light_rendered',
  HOLIDAY_GUESS: 'holiday_guess',
  UPLOAD_YOUTUBE_DRAFT_CREATED: 'upload_youtube_draft_created',
  UPLOAD_PUBLISHED_PAGE_VIEWED: 'upload_published_page_viewed',
  ROOKIE_CARD_DOWNLOADED: 'rookie_card_downloaded',
  ROOKIE_CARD_POST_TEXT_COPIED: 'rookie_card_post_text_copied',
  CERTIFICATE_DOWNLOADED: 'certificate_downloaded',
  CERTIFICATE_TEXT_COPIED: 'certificate_text_copied',
  FEEDBACK_REPORT_SENT: 'feedback_report_sent',
  HOA_LETTER_REQUESTED: 'hoa_letter_requested',
  HOA_LETTER_DOWNLOADED: 'hoa_letter_downloaded',
  HOA_LETTER_TEXT_COPIED: 'hoa_letter_text_copied',
  BOUNTY_BOARD_VIEWED: 'bounty_board_viewed',
  BOUNTY_UPVOTED: 'bounty_upvoted',
  BOUNTY_REQUESTED: 'bounty_requested',
  PORCH_NOTE_POSTED: 'porch_note_posted',
  PORCH_NOTE_REPORTED: 'porch_note_reported',
  SEQUENCE_EDIT_SAVED: 'sequence_edit_saved',
  DISPLAY_CREATE_STARTED: 'display_create_started',
  DISPLAY_CREATED: 'display_created',
  DISPLAY_UPDATED: 'display_updated',
  DISPLAY_PHOTO_ADDED: 'display_photo_added',
  MY_DISPLAYS_VIEWED: 'my_displays_viewed',
  DISPLAY_SEASON_CREATED: 'display_season_created',
  DISPLAY_SONG_ADDED: 'display_song_added',
  DISPLAY_PROP_ADDED: 'display_prop_added',
  SCHEDULE_UPDATED: 'schedule_updated',
  SEQUENCER_VIEWED: 'sequencer_viewed',
  SEQUENCER_LINK_CLICKED: 'sequencer_link_clicked',
  PROP_VENDOR_VIEWED: 'prop_vendor_viewed',
  PROP_PRODUCT_VIEWED: 'prop_product_viewed',
  PROP_PRODUCT_LINK_CLICKED: 'prop_product_link_clicked',
  INSTALLER_VIEWED: 'installer_viewed',
  INSTALLER_CONTACTED: 'installer_contacted',
  FAVORITE_TOGGLED: 'favorite_toggled',
  ROUTE_STOP_ADDED: 'route_stop_added',
  ROUTE_VIEWED: 'route_viewed',
  DISPLAY_REVIEW_SUBMITTED: 'display_review_submitted',
  SEQUENCE_REVIEW_SUBMITTED: 'sequence_review_submitted',
  SEQUENCE_UPVOTED: 'sequence_upvoted',
  DISPLAY_UPVOTED: 'display_upvoted',
  DISPLAY_CLAIMED: 'display_claimed',
  DISPLAY_SEQUENCES_LINK_CLICKED: 'display_sequences_link_clicked',
  CLAIM_SONGS_OFFERED: 'claim_songs_offered',
  PREBUILT_DRAFTS_CREATED: 'prebuilt_drafts_created',
  SIGN_SCANNED: 'sign_scanned',
  SIGN_UPVOTED: 'sign_upvoted',
  SIGN_UPVOTES_SAVED: 'sign_upvotes_saved',
  RF_VOTE_SUBMITTED: 'rf_vote_submitted',
  RF_REQUEST_SUBMITTED: 'rf_request_submitted',
  RF_VOTE_REJECTED: 'rf_vote_rejected',
  LOR_BALLOT_VIEWED: 'lor_ballot_viewed',
  VOTE_JUMP_CLICKED: 'vote_jump_clicked',
  VOTE_SIGN_PRINTED: 'vote_sign_printed',
  LOR_VOTE_SUBMITTED: 'lor_vote_submitted',
  LOR_VOTE_REJECTED: 'lor_vote_rejected',
  VOTING_MATCHES_CONFIRMED: 'voting_matches_confirmed',
  SHOW_TOOLS_VIEWED: 'show_tools_viewed',
  LOR_HOURS_CONFIRMED: 'lor_hours_confirmed',
  LOR_HOURS_SYNC_STOPPED: 'lor_hours_sync_stopped',
  CLOCK_MODE_SAVED: 'clock_mode_saved',
  CLOCK_MODE_SYNCED: 'clock_mode_synced',
  OWNER_FOCUS_SET: 'owner_focus_set',
  SELL_PAGE_VIEWED: 'sell_page_viewed',
  AI_CONNECTOR_PAGE_VIEWED: 'ai_connector_page_viewed',
  AI_CONNECTOR_ADDRESS_COPIED: 'ai_connector_address_copied',
  SELL_CTA_CLICKED: 'sell_cta_clicked',
  FOR_OWNERS_PAGE_VIEWED: 'for_owners_page_viewed',
  FOR_OWNERS_CTA_CLICKED: 'for_owners_cta_clicked',
  FOR_OWNERS_DISPLAY_PAGE_VIEWED: 'for_owners_display_page_viewed',
  FOR_OWNERS_DISPLAY_PAGE_CTA_CLICKED: 'for_owners_display_page_cta_clicked',
  FOR_OWNERS_FIRST_SHOW_VIEWED: 'for_owners_first_show_viewed',
  FOR_OWNERS_FIRST_SHOW_CTA_CLICKED: 'for_owners_first_show_cta_clicked',
  FOR_OWNERS_FIRST_SHOW_STAGE_CHANGED: 'for_owners_first_show_stage_changed',
  CLAIM_SEARCH_PERFORMED: 'claim_search_performed',
  CLAIM_MATCH_SHOWN: 'claim_match_shown',
  CLAIM_MATCH_DISMISSED: 'claim_match_dismissed',
  INSTALLERS_PAGE_VIEWED: 'installers_page_viewed',
  INSTALLERS_CTA_CLICKED: 'installers_cta_clicked',
  WAITLIST_FORM_STARTED: 'waitlist_form_started',
  WAITLIST_SIGNUP_COMPLETED: 'waitlist_signup_completed',
  WAITLIST_SIGNUP_FAILED: 'waitlist_signup_failed',
  VOICE_REWARDS_VIEWED: 'voice_rewards_viewed',
  VOICE_REWARD_CLAIMED: 'voice_reward_claimed',
  SELLER_DASHBOARD_VIEWED: 'seller_dashboard_viewed',
  SELLER_PAYOUT_VIEWED: 'seller_payout_viewed',
  SMS_ALERTS_OPTED_IN: 'sms_alerts_opted_in',
  EMAIL_PREFERENCES_UPDATED: 'email_preferences_updated',
  STUDIO_DASHBOARD_VIEWED: 'studio_dashboard_viewed',
  STUDIO_PROJECT_CREATED: 'studio_project_created',
  HELP_SEARCH_NO_RESULTS: 'help_search_no_results',
  HELP_ARTICLE_VIEW: 'help_article_view',
  HELP_ARTICLE_VOTE: 'help_article_vote',
  HELP_LINK_CLICK: 'help_link_click',
} as const;

type Client = typeof import('posthog-js')['default'];
type Pending = (client: Client) => void;

// posthog-js is ~250 KiB minified and was the largest single item in the
// entry chunk. It loads on demand so the shell paints first. Calls that
// arrive while it is still loading (a cold load straight onto a display
// page fires DISPLAY_VIEWED almost immediately) are queued and flushed in
// order once init completes, so nothing is dropped.
let client: Client | null = null;
let loading: Promise<void> | null = null;
let pending: Pending[] = [];

function withClient(fn: Pending): void {
  if (client) fn(client);
  else if (loading) pending.push(fn);
  // No key configured: analytics is off and calls are dropped, as before.
}

export function initAnalytics(): void {
  const apiKey = import.meta.env.VITE_POSTHOG_KEY as string | undefined;
  if (!apiKey || loading) return;
  loading = import('posthog-js')
    .then(({ default: posthog }) => {
      posthog.init(apiKey, {
        api_host: (import.meta.env.VITE_POSTHOG_HOST as string | undefined) ?? 'https://us.i.posthog.com',
        // Pageviews stay with Vercel Analytics; PostHog carries the named events.
        capture_pageview: false,
        persistence: 'localStorage+cookie',
      });
      client = posthog;
      const queued = pending;
      pending = [];
      for (const fn of queued) fn(posthog);
    })
    .catch(() => {
      // A blocked or failed load must not wedge the app; drop the queue and
      // let a later initAnalytics() try again.
      loading = null;
      pending = [];
    });
}

// Added to every event this page sends, in memory only (the embedded vote card sets { embed: true }).
// Not PostHog's register(), which would persist to storage and leak into the same origin's other pages.
let defaultProperties: Record<string, unknown> = {};

export function setDefaultEventProperties(properties: Record<string, unknown>): void {
  defaultProperties = properties;
}

export function track(event: string, properties?: Record<string, unknown>): void {
  const merged = Object.keys(defaultProperties).length > 0 ? { ...defaultProperties, ...properties } : properties;
  withClient((c) => c.capture(event, merged));
}

export function identifyUser(userId: string, properties?: Record<string, unknown>): void {
  withClient((c) => c.identify(userId, properties));
}

export function resetUser(): void {
  withClient((c) => c.reset());
}
